<script setup lang="ts">
import { IonButton } from '@ionic/vue';
withDefaults(
  defineProps<{
    type?: 'button' | 'reset' | 'submit';
    disabled?: boolean;
    color?: 'light' | 'white';
  }>(),
  { color: 'light' }
);
</script>

<template>
  <ion-button
    class="transition-colors"
    expand="block"
    :color="color === 'light' ? 'xlight' : 'white'"
    :type="type"
    :disabled="disabled"
  >
    <slot></slot>
  </ion-button>
</template>

<style scoped>
ion-button {
  --border-radius: 4px;
}
</style>
